import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { subjectSlug } from "@/lib/rankingSlug";

let directory;
let rankings;

export function resetGuidesCache() {
  directory = undefined;
}

// Published subject guides (one shared request per page load); empty when none or on error.
export function usePublishedGuides() {
  const [guides, setGuides] = useState(null);
  useEffect(() => {
    directory = directory || api.get("/subjects").then((r) => r.data.guides).catch(() => []);
    let live = true;
    directory.then((g) => live && setGuides(g));
    return () => { live = false; };
  }, []);
  return { guides: guides || [], loaded: guides !== null, bySubjectId: new Map((guides || []).map((g) => [g.subject_id, g])) };
}

// UK subject-ranking link for a guide, only when that ranking has data.
export function useUkRanking(name) {
  const [href, setHref] = useState(null);
  useEffect(() => {
    if (!name) return undefined;
    rankings = rankings || api.get("/rankings/subject-index").then((r) => r.data.countries?.UK || []).catch(() => []);
    let live = true;
    rankings.then((rows) => {
      const names = rows.map((x) => (typeof x === "string" ? x : x.subject));
      if (live && names.includes(name)) setHref(`/rankings/uk/${subjectSlug(name)}`);
    });
    return () => { live = false; };
  }, [name]);
  return href;
}
